import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, finalize, Observable, tap, throwError } from 'rxjs';
import Swal from 'sweetalert2';
import { UserIpService } from './UserIpService/userIp.service';
import { SwalAlertService } from './SwalAlertService/swalAlert.service';

@Injectable()
export class InterceptorService implements HttpInterceptor {
  constructor(
    private userIpService: UserIpService,
    private swalAlert: SwalAlertService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token')?.replaceAll('"', ' ');
    let authReq = req;

    let ip = localStorage.getItem('ipv4') ?? '';

    if (
      token &&
      !req.url.includes('viacep') &&
      !req.url.includes('ipify') &&
      !req.url.includes('ImprimirTicket') &&
      !req.url.includes('Login')
    ) {
      authReq = req.clone({
        setHeaders: {
          'Access-Control-Allow-Origin': '*',
          type: 'application/json',
          Authorization: `Bearer ${token}`,
          ipv4: String(ip)
        }
      });
    }

    return next.handle(authReq).pipe(
      tap((response: any) => {
        const status = [200, 201];

        if (status.includes(response.status) && authReq.method !== 'GET') {
          if (authReq.method == 'POST' && !authReq.url.includes('Login')) {
            this.swalAlert.showAlert(
              'Sucesso!',
              'Cadastro realizado com sucesso.',
              'success',
              false,
              false,
              undefined
            );
          }

          if (authReq.method == 'PUT') {
            this.swalAlert.showAlert(
              'Sucesso!',
              'Edição realizada com sucesso.',
              'success',
              false,
              false,
              undefined
            );
          }

          if (authReq.method == 'PATCH') {
            this.swalAlert.showAlert(
              'Sucesso!',
              'Alteração realizada com sucesso.',
              'success',
              false,
              false,
              undefined
            );
          }
        }
      }),
      catchError((error: HttpErrorResponse) => {
        const errorMessage = '';

        if (error.error && error.error.Errors) {
          if (error.error.Errors.Error) {
            const mensagensErro = error.error.Errors.Error;
            Swal.fire({
              title: 'Alerta!',
              icon: 'warning',
              html: mensagensErro,
              width: '50%',
              confirmButtonColor: 'green',
              confirmButtonText: 'Ok'
            });
          } else {
            const mensagensErro = error.error.Errors;
            this.swalAlert.showAlert(
              'Alerta!',
              mensagensErro,
              'warning',
              false,
              false,
              undefined
            );
          }

          return throwError(errorMessage);
        }

        if (error.error) {
          let errorMessage = error.error;
          let listError;
          let errorMessageStyle =
            '<div style="max-height: 30vh; overflow-y: auto; text-align: left;"><ul>';

          listError =
            typeof errorMessage === 'string'
              ? JSON.parse(errorMessage)
              : errorMessage;

          listError.forEach((x: any, index: number) => {
            if (index > 0) {
              errorMessageStyle += '<br>';
            }
            errorMessageStyle += `• ${x}` + '<br>';
          });

          errorMessageStyle += '</ul>';
          Swal.fire({
            title: 'Alerta!',
            html: errorMessageStyle,
            icon: 'warning',
            width: '50vh',
            confirmButtonColor: 'green',
            confirmButtonText: 'Ok'
          });
          return throwError(errorMessage);
        } else {
          this.swalAlert.showAlert(
            'Alerta!',
            'Ocorreu um erro ao realizar a operação, tente novamente.',
            'warning',
            false,
            false,
            undefined
          );
          return throwError(errorMessage);
        }
      }),
      finalize(() => {})
    );
  }
}
